// import React from 'react';
// import ProductListingCard from './ProductListingCard';

// const ProductListing = ({ trending }: any) => {
//   return (
//     <section className="product-listing padding-top padding-bottom section-bg">
//       <div className="container">
//         <div className="section-header justify-content-center">
//           <h2 className="section-title mb-2 mb-sm-0">Trending Products</h2>
//         </div>
//         <div
//           className="product-listing__wrapper"
//           data-aos="fade-up"
//           data-aos-duration={1000}
//         >
//           <div className="row  justify-content-center g-5 g-lg-4">
//             {trending?.length > 0 &&
//               trending.map(
//                 (trend: any, ind: number) =>
//                   trend?.products?.length > 0 && (
//                     <div key={ind} className="col-xl-4 col-md-6">
//                       <ProductListingCard
//                         products={trend.products.slice(0, 3)}
//                         title={trend.category_name}
//                         categoryUrl={trend?.category_url}
//                       />
//                     </div>
//                   )
//               )}
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default ProductListing;

// src/features/product_listing/components/ProductListing.tsx

// This is now a Server Component. It doesn't need 'use client'.
'use client';
// import { fetcher } from '@/lib/fetcher';
import ProductListingCard from './ProductListingCard';
import { useFetcherCSR } from '@/lib/useFetcherCSR';
import { SaleBannerSkeleton } from '@/features/home/SaleBanner/components/SaleBannerSkeleton';
import { API_HOME_THINGS } from '@/constant/apiRout';

// The component is now ASYNC and takes NO PROPS
const ProductListing = () => {
  // ✅ DATA IS FETCHED HERE, INSIDE THE COMPONENT
  const { data: homeThings, isLoading } = useFetcherCSR(API_HOME_THINGS);

  if (isLoading) return <SaleBannerSkeleton />;

  const trending = homeThings?.trending ?? [];

  if (trending.length === 0) {
    return null;
  }

  return (
    <section className="product-listing padding-top padding-bottom section-bg">
      <div className="container">
        <div className="section-header justify-content-center">
          <h2 className="section-title mb-2 mb-sm-0">Trending Products</h2>
        </div>
        <div className="product-listing__wrapper">
          <div className="row justify-content-center g-5 g-lg-4">
            {trending.map(
              (trend: any, ind: number) =>
                trend?.products?.length > 0 && (
                  <div key={ind} className="col-xl-4 col-md-6">
                    <ProductListingCard
                      products={trend.products.slice(0, 3)}
                      title={trend.category_name}
                      categoryUrl={trend?.category_url}
                    />
                  </div>
                )
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductListing;
